<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-newspaper"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row>
        <v-col class="white rounded-lg" cols="12">
          <v-row>
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="news.name"
                    filled
                    label="Name"
                    placeholder="Enter news name"
                    @keyup="onKeyUp"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="news.slug"
                    @blur="getSeo"
                    filled
                    label="Slug"
                    placeholder="Nhập slug"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                    v-model="news.short_description"
                    filled
                    label="Short description"
                    placeholder="Enter short description"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <div class="mb-4">Description</div>
                <ck-content :content="news.description" class="ck-project"
                            @getData="value => news.description = value" @blur="getSeo"></ck-content>
              </v-col>
            </v-col>
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="news.name_vi"
                    filled
                    label="Tên"
                    placeholder="Nhập tên bài viết"
                ></v-text-field>
              </v-col>
              <v-col cols="12" style="margin-bottom: 86px"></v-col>
              <v-col cols="12">
                <v-textarea
                    v-model="news.short_description_vi"
                    filled
                    label="Mô tả ngắn"
                    placeholder="Nhập mô tả"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <div class="mb-4">Mô tả</div>
                <ck-content :content="news.description_vi" class="ck-project"
                            @getData="value => news.description_vi = value" @blur="getSeo"></ck-content>
              </v-col>
            </v-col>
          </v-row>


          <v-col cols="12">
            <v-text-field
                filled
                @blur="getSeo"
                v-model="news.seo_title"
                label="SEO Title"
                placeholder="Nhập SEO Title"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
                filled
                @blur="getSeo"
                v-model="news.seo_description"
                label="SEO Description"
                placeholder="Nhập SEO Description"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
                filled
                label="SEO Keyword"
                placeholder="Nhập SEO Keyword"
                v-model="news.seo_key"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-file-input
                label="Ảnh "
                placeholder="Tải ảnh lên"
                prepend-icon="mdi-camera"
                v-model="image"
                @change="uploadImg"
            ></v-file-input>
            <div v-if="display_image">
              <v-img
                  :src="display_image"
                  aspect-ratio="1.7"
                  contain
              ></v-img>
            </div>
          </v-col>
        </v-col>
        <v-col class="white rounded-lg mt-3" cols="12">
          <v-row class="mx-3">
            <h4 class="my-5">Hỗ trợ SEO</h4>
            <v-col cols="12">
              <v-text-field
                  counter="200"
                  label="Focus Keyword"
                  type="text"
                  v-model="text_seo"
                  @blur="getSeo"
              ></v-text-field>
            </v-col>
            <v-col
                class="rounded-lg mb-5"
                cols="12"
                style="border: 1px solid #dadada"
            >
              <div class="d-flex ">
                <h5 class="pt-2 mr-3">Basic SEO</h5>
                <div
                    class="rounded-xl white--text text-center"
                    style="
                    background: #f39d96;
                    width: 100px;
                    height: 35px;
                    line-height: 32px;
                  "
                    v-if="errors_ > 0"
                >
                  <v-icon color="white">mdi-close</v-icon>
                  {{ errors_ }}
                </div>
              </div>
              <div v-for="(item, index) in SEO" v-bind:key="index" class="mt-3">
                <v-icon
                    class="mr-2"
                    color="white"
                    size="20"
                    style="background: #f39d96; border-radius: 50%"
                >mdi-close
                </v-icon
                >
                {{ item.title }}
                <v-icon color="#B6BFC9">help</v-icon>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="text-center" cols="12">
          <v-btn color="primary" width="180" @click="save()"> Lưu</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import CkContent from "@/components/ck-content"
import {SAVE_NEWS} from "@/store/modules/news";
import {GET_LIST_SEO} from "@/store/modules/seo";
import {UPLOAD_IMAGE} from "@/store/modules/field_project";
import validateSlug from "@/mixins/validateSlug";

export default {
  name: "Add_new",
  mixins: [validateSlug],
  components: {
    CkContent
  },
  data() {
    return {
      page: "Thêm tin tức",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách tin tức",
          disabled: true,
        },
        {
          text: "Thêm tin tức",
          disabled: false,
        },
      ],

      image: null,
      display_image: '',

      text_seo: "",
      errors_: 0,
      SEO: [],
      news: {
        name: '',
        name_vi: '',
        slug: '',
        short_description: '',
        short_description_vi: '',
        description: '',
        description_vi: '',
        seo_title: '',
        seo_description: '',
        seo_key: '',
        photo_url: '',
      }
    }
  },
  methods: {
    onKeyUp(value) {
      this.news.slug = this.sanitizeTitle(value.target.value)
    },
    uploadImg(e) {
      if (e) {
        this.display_image = URL.createObjectURL(e)
      }
      this.$forceUpdate()
    },
    getSeo() {
      let formData = new FormData();
      formData.append("keyword", this.text_seo);
      formData.append("title", this.news.seo_title);
      formData.append("data_content", this.news.description);
      formData.append("slug", this.news.slug);
      formData.append("meta_description", this.news.seo_description);
      this.$store.dispatch(`${GET_LIST_SEO}`, formData).then((data) => {
        if (data.data.status == 0) {
          this.SEO = [];
          data.data.errors.forEach((element) => {
            let data = {
              title: element,
            };
            this.SEO.push(data);
          });
          this.errors_ = this.SEO.length
        } else {
          // alert(data.data.errors)
        }
      });
    },
    async save() {
      let formDateAvatar = new FormData();
      formDateAvatar.append("upload", this.image);
      formDateAvatar.append("type", "ckeditor");
      formDateAvatar.append("position_type", "1");
      await this.$store.dispatch(`${UPLOAD_IMAGE}`, formDateAvatar).then((data) => {
            if (data.data.status == 1) {
              this.news.photo_url = data.data.data[0].path
            }
          }
      )
      let data = {
        name: this.news.name,
        name_vi: this.news.name_vi,
        slug: this.news.slug,
        short_description: this.news.short_description,
        short_description_vi: this.news.short_description_vi,
        description: this.news.description,
        description_vi: this.news.description_vi,
        photo_url: this.news.photo_url,
        seo_key: this.news.seo_key,
        seo_description: this.news.seo_description,
        seo_name: this.news.seo_title,
        count_view: 0,
        active: 0,
        highight: 0,
      }
      await this.$store.dispatch(`${SAVE_NEWS}`, data).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$router.push('/news')
        } else {
          alert(data.data.errors)
        }
      });
    }
  }
}
</script>

<style scoped>

</style>